<app-modal-shell
  [title]="'EMAIL_DATA.TITLE'"
  [cancelLabel]="'EMAIL_DATA.BUTTONS.CANCEL'"
  [saveLabel]="'EMAIL_DATA.BUTTONS.OK'"
  [saveDisabled]="saveDisabled"
  (cancelClicked)="cancel()"
  (saveClicked)="save()">

  <div class="form-group">
    <app-email-details-form [initialData]="emailDetails" testIdPrefix="email-data-"></app-email-details-form>
  </div>

</app-modal-shell>
